import { registerFr } from '../i18n/index.js';

registerFr({
  'Dossier': 'Dossier',
  'No dossier yet. Research runs nightly for tier A, weekly for tier B, or now. A dossier is a document, not a fact: it keeps its ◇ mark for ever, and no verb turns one of its sentences into a fact. Each [n] expands to the verbatim quote and the snapshot it was read from.': 'Pas encore de dossier. La recherche tourne chaque nuit pour le rang A, chaque semaine pour le rang B, ou maintenant. Un dossier est un document, pas un fait : il garde son ◇ pour toujours, et aucun verbe ne transforme l’une de ses phrases en fait. Chaque [n] déplie la citation littérale et l’instantané dont elle est tirée.',
  'a document with its receipts, never a fact': 'un document avec ses justificatifs, jamais un fait',
  'written by an agent; a dossier is never held': 'écrit par un agent ; un dossier n’est jamais retenu',
  'written by': 'écrit par',
  '{n} version': '{n} version',
  '{n} versions': '{n} versions',
  'Previous versions': 'Versions précédentes',
  'Hide versions': 'Masquer les versions',
  'Versions': 'Versions',
  'The versions could not be listed.': 'Les versions n’ont pas pu être listées.',
  'Showing version {v}; the latest is version {latest}.': 'Version {v} affichée ; la plus récente est la version {latest}.',
  'Back to the latest': 'Revenir à la plus récente',
  'shown': 'affichée',
  'Show': 'Afficher',
  'Untitled dossier': 'Dossier sans titre',
  'show the quote behind [{n}]': 'afficher la citation derrière [{n}]',
  'this citation is not in the list': 'cette référence n’est pas dans la liste',
  'fetch date not recorded': 'date de capture non enregistrée',
  '{n} source': '{n} source',
  '{n} sources': '{n} sources',
  'Hide sources': 'Masquer les sources',
  'The dossier could not be read: {error}': 'Le dossier n’a pas pu être lu : {error}',
}, 'DossierZone');
